exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-select[data-v-065c168d] {\n  display: block;\n}\n.ph1[data-v-065c168d] {\n  background-color: #ddf6f3;\n}\n.ph3[data-v-065c168d] {\n  background-color: #d9edf7;\n}\n.error-message[data-v-065c168d] {\n  color: red;\n}", ""]);

// exports
